const enumProxyHandler = () => {
    return {
        get: (target, prop, proxy) => {
            if (Object.hasOwn(target, prop)) {
                if (typeof target[prop] === 'function') {
                    const originFun = target[prop];
                    return (...args) => {
                        return originFun.apply(target, args);
                    };
                }
                Reflect.get(target, prop, proxy);
            } else if (Object.hasOwn(target, `${prop}_`)) {
                return prop;
            } else if (prop === `getPairs`) {
                return () =>
                    Object.keys(target)
                        .filter((v) => typeof target[v] !== 'function' && typeof target[v] !== 'object')
                        .map((key) => ({ key: key.slice(0, -1), value: target[key] }));
            } else {
                Reflect.get(target, prop, proxy);
            }
        },
    };
};

/*

Example:
const _deviceVariant = {
    "std_":               "Standard",
    "lts_":               "Long Term Storage",
};

export const DeviceVariant = Enum.proxy(_deviceVariant);

Client:

console.log(DeviceVariant.std); # output "std"
console.log(DeviceVariant.std_); # output "Standard"

*/
class MapEnum {
    static proxy(ins) {
        return new Proxy(ins, enumProxyHandler());
    }
}

export default MapEnum;
